<div class="overlay">
  <div class="confirm-box">
    <div class="icon-header">
      <mat-icon class="head">warning</mat-icon>
    </div>
    <h3 class="header">Confirm Action</h3>
    <p>{{ data }}</p>
    <div class="actions">
      <button mat-button (click)="onCancel()">CANCEL</button>
      <button mat-raised-button class="del" (click)="onConfirm()">OK</button>
    </div>
  </div>
</div>
